<template>
  <div id="app-root" style="height: 100%; width: 100%;">
    <div v-if="!isReady" class="preloader">
      <img style="width: 60px; height: 60px" src="/logo.png" />
      <div style="margin-top: 12px; color: #479a5e">
        <b style="color: #275fcb; margin-left: 2px">Salework </b>Contact
      </div>
    </div>
    <div v-else id="app" class="h-100">
      <el-container class="h-100">
        <NewVersionBar v-if="!app.isEmbed" />
        <el-header v-if="!app.isEmbed" class="p-0" style="height: 48px">
          <Navbar />
        </el-header>
        <el-container>
          <el-aside v-if="!app.isEmbed" style="transition: all 0.4s ease;" :width="menuOpen ? '220px' : '60px'">
            <Sidebar :menuOpen="menuOpen" />
          </el-aside>
          <el-main :style="{
            overflow: 'hidden',
            height: app.isEmbed ? '100vh' : 'calc(100vh - 48px - var(--sw-topbar-h, 0px))',
            padding: '0 !important'
          }">
            <router-view></router-view>
            <div v-if="!app.isEmbed && app.stringee && app.stringee?.status == 'ACTIVE'" style="
              position: absolute;
              right: 50px;
              bottom: 30px;
              z-index: 10000;
            ">
              <el-button type="primary" circle size="large" @click="handleStringeeDialog" style="
                display: flex;
                justify-content: center;
                align-items: center;
              ">
                <IconFont color="#FFF" size="20px" name="icon-phone" />
              </el-button>
            </div>
          </el-main>

          <div v-if="!app.isEmbed" class="btn-collapse d-flex align-items-center justify-content-center"
            :class="!menuOpen ? 'collapse' : ''" @click="collapseMenu()">
            <icon-font v-if="menuOpen" style="margin-bottom: 1px;" name="icon-arrow1-left" size="28px" color="#FFF" />
            <icon-font v-if="!menuOpen" style="margin-bottom: 1px;" name="icon-arrow1-right" size="28px" color="#FFF" />
          </div>
          <call-note v-if="callResultData" :data="callResultData" @close="callResultData = null" />
          <call-note-pitel v-if="callResultPitel" :data="callResultPitel" @close="callResultPitel = null" />
          <call-note-stringee v-if="callStringeeData" :data="callStringeeData" @close="callStringeeData = null" />

          <call-note-stringee-inbound v-if="callStringee" :data="callStringee" @close="callStringee = null" />
        </el-container>
      </el-container>
    </div>
    <OnBoarding v-if="app.showOnboarding" :initial-business-info="aiBusinessInfo" />
    <BannerPremium v-if="false" ref="bannerPremium" @close="handleBannerClose" />
  </div>
</template>

<script>
import Sidebar from "@/components/common/Sidebar.vue";
import Navbar from "@/components/common/Navbar.vue";
import BannerPremium from "@/components/common/BannerPremium.vue";
import NewVersionBar from "@/components/common/NewVersionBar.vue";
import OnBoarding from "@/components/OnBoarding.vue";
import initApi from "@/lib/apis/initData";
import { HTTP } from "./lib/http-common";
import { initOmiCallSDK } from "./lib/omicall";
import { initSwCall } from "./lib/swCall";
import { initAISDK } from "./lib/AI";
import CallNote from "./components/Call/CallNote.vue";
import CallNotePitel from "./components/Call/CallNotePitel.vue";
import CallNoteStringee from "./components/Call/CallNoteStringee.vue";
import CallNoteStringeeInbound from "./components/Call/CallNoteStringeeInbound.vue";
import { initStringeeSDK } from "./lib/stringee";
import { initSDK } from "./lib/pitel";
import IconFont from "./components/common/IconFont.vue";
import { showReminderToast } from "./lib/toastHelper.js";

export default {
  name: "App",
  components: {
    Navbar,
    Sidebar,
    BannerPremium,
    NewVersionBar,
    CallNote,
    CallNotePitel,
    CallNoteStringee,
    CallNoteStringeeInbound,
    IconFont,
    OnBoarding,
  },
  watch: {
    'app.showOnboarding'(newVal, oldVal) {
      if (oldVal && !newVal) {
        this.initAfterOnboarding();
      }
    },
  },
  data() {
    return {
      isReady: false,
      callResultData: null,
      callResultPitel: null,
      callStringeeData: null,
      callStringee: null,
      apiSidKey: "",
      apiSecretKey: "",
      showModeStringee: "none",
      showNoticontact: false,
      contactNoti: {},
      menuOpen: true,
      appointmentTimer: null,
      isEmbed: false,
      showExpireBanner: false,
      aiBusinessInfo: null,
      companyCallList: ['esbt', 'sota'],
      companyAIList: ['sota', 'esbt'],
      employeesAI: ['sota/trongvu', 'sota/thang'],
    };
  },
  methods: {
    async verify() {
      try {
        const res = await initApi.verify();
        if (!res || !res.data || !res.data.accessToken) {
          // if (this.$refs.bannerPremium) {
          //   this.$refs.bannerPremium.show(true);
          // }
          // return;
          window.location = "https://salework.net/login?target=contact";
        }
        this.fetchDataLocal(res);
      } catch (ex) {
        window.location = "https://salework.net/login?target=contact";
      }
    },
    handleBannerClose() {
      if (!this.isReady) {
        window.location = "https://salework.net/login?target=contact";
      }
    },
    fetchDataLocal(res) {
      this.app.shopExpired = false;
      let data = res.data;
      this.app.paymentType = data.paymentType;
      
      localStorage.setItem("bearerToken", res.data.accessToken);
      localStorage.setItem("cToken", res.data.ctoken);
      this.app.user = res.data.user;
      // Công ty sota chỉ dùng bản mới (/v2) — chuyển thẳng, KHÔNG cho vào v1.
      // Dùng location.replace để URL v1 không nằm trong history (bấm back cũng
      // không quay lại v1 được). Giữ nguyên path + query (kể cả ?embed=true) để
      // mở đúng trang tương ứng bên v2.
      const companyCode = String((this.app.user && this.app.user.companyCode) || "")
        .trim()
        .toLowerCase();
      // Ghi lại để script inline trong index.html biết ngay ở lần vào sau, không
      // phải chờ verify. Ghi cho mọi công ty, không riêng công ty đã lên v2.
      localStorage.setItem("companyCode", companyCode);
      if (companyCode === "sota") {
        const path =
          window.location.pathname === "/" ? "/" : window.location.pathname;
        window.location.replace(
          "https://contact.salework.net/v2" + path + window.location.search
        );
        return;
      }
      if (this.app.user && this.app.user.companyCode) {
        document.title = `Salework Contact (${this.app.user.companyCode})`;
      }
      this.app.user.swUsernameLite = this.app.user.type === 'EMPLOYEE' ? this.app.user.swUsername.replace(/\//g, "") : this.app.user.companyCode;
      this.app.staffLimit = data.staffLimit;
      this.app.sessionId = data.sessionId;
      this.app.staffLimit = data.staffLimit;
      if (!this.app.shopExpired) {
        if (
          this.app.user.type === "EMPLOYEE" && this.$route.path == '/'
        ) {
          this.$router.push("/contact");
        }
        if (this.app.user.type == "ADMIN" && this.$route.path == '/') {
          this.$router.push('/dashboard');
        }

        if (typeof window !== "undefined" && typeof window.gtag === "function") {
          window.gtag("set", { user_id: this.app.user.companyCode });
        }
        setTimeout(async () => {
          await this.getProcessList();
          await this.getColumnExtends();

          this.aiBusinessInfo = await this.fetchAiBusinessInfo();
          const hasBusinessConfig = !!this.aiBusinessInfo;
          this.$set(this.app, 'showOnboarding', !hasBusinessConfig);

          if (hasBusinessConfig) {
            await this.initAfterOnboarding();
          }
          this.isReady = true;

          if (this.app.paymentType === 'TRIAL' && this.$refs.bannerPremium) {
            this.$refs.bannerPremium.show();
          }
        }, 200);
      } else {
        this.showExpireBanner = true;
      }
    },
    handleAlarmAppointment(data) {
      showReminderToast(data, (remindTimeText, appointmentId, contactId) => {
        HTTP.post('/api/appointment/noti-again', null, {
          params: {
            appointmentId: appointmentId,
            contactId: contactId,
            timeAgain: remindTimeText
          }
        });
      });
    },
    getInitData() {
      this.initWebsocket();
      this.getColumnExtends();
      // this.getProcessList();
      this.getPermissionList();
      this.getEmployeeList();
      this.getStorageList();
      // this.getWorkflowList();
      this.getReportList();
      this.checkAndFetchNotification();
      if (!this.app.isEmbed) {
        this.getConnectionSwCall();
      }
      if (!this.app.isEmbed && this.app.paymentType === 'PREPAYMENT' && (this.app.user.type === 'ADMIN' || this.employeesAI.includes(this.app.user.swUsername))) {
        this.getConnectionAI();
      }
    },
    async checkAndFetchNotification() {
      const key = `${this.app.user.id}_${this.app.user.swUsername}`;
      const unreadMap = JSON.parse(localStorage.getItem("notiUnread") || "{}");
      const preClickMap = JSON.parse(localStorage.getItem("preBellClick") || "{}");

      const fetchAndCountUnread = async () => {
        const time = new Date().toISOString().slice(0, 10);
        const res = await this.fetchNotification(time, 9);
        this.app.notifications = res;

        return (this.app.notifications || []).reduce((count, group) => {
          const list = group?.listNotification || [];
          return count + list.filter(n => n.status === "UNREAD").length;
        }, 0);
      };

      if (unreadMap[key] == null) {
        const totalUnread = await fetchAndCountUnread();
        this.$set(this.app, "countUnreadNoti", totalUnread);
        this.setUnreadCountNoti(key, totalUnread);
      } else if (preClickMap[key] == null) {
        this.app.countUnreadNoti = unreadMap[key];
      } else {
        const totalUnread = await fetchAndCountUnread();
        const diffUnread = totalUnread - unreadMap[key];
        this.$set(this.app, "countUnreadNoti", diffUnread);
        this.setUnreadCountNoti(key, diffUnread);
      }

      const fetchAndCountUnreadAppointment = async () => {
        const time = new Date().toISOString().slice(0, 10);
        const res = await this.fetchNotificationAppointment(time, 3);
        this.app.notificationAppointments = res;

        return (this.app.notificationAppointments || []).reduce((count, group) => {
          const list = group?.listNotification || [];
          return count + list.filter(n => n.status === "UNREAD").length;
        }, 0);
      };
      const unreadAppointment = await fetchAndCountUnreadAppointment();
      this.$set(this.app, "countUnreadNotiAppointment", unreadAppointment);
    },
    handleNotification(data) {
      // let notification = this.app.notifications.find(noti => noti.type === data.type);
      // if (!notification) {
      //   this.app.notifications.unshift({
      //     updateAt: new Date().getTime(),
      //     type: data.type,
      //     status: "UNREAD",
      //     listNotification: [data]
      //   })
      // } else {
      //   notification.listNotification.unshift(data);
      // }

      console.log(data);
      this.app.countUnreadNoti += 1;
      this.app.showNotifyPopover = true;
      this.$bus.$emit("newContact", data);
      // let key = `${this.app.user.id}_${this.app.user.swUsername}`;
      // this.setUnreadCountNoti(key, this.app.countUnreadNoti);

      // this.app.notifications.sort((a, b) => b.updateAt - a.updateAt);
    },
    handleNotificationAppointment(data) {
      console.log(data);
      this.$bus.$emit("notiUpdateAppointment", data);
      this.app.countUnreadNotiAppointment += 1;
    },
    async initAfterOnboarding() {
      this.getInitData();
      await this.getProcessList();
      this.updateDisplay();
    },
    async fetchAiBusinessInfo() {
      try {
        const res = await HTTP.get('/api/ai-business', {
          params: { companyCode: this.app.user.companyCode, userId: this.app.user.id },
        });
        if (!res?.data) return null;
        const root = JSON.parse(res.data).data?.data || {};
        return root.aiBusinessInfo || null;
      } catch (e) {
        return null;
      }
    },
    async getProcessList() {
      const res = await HTTP.get("/api/process");
      this.$set(this.app, "processList", res.data);
      this.app.processList.unshift({
        id: 'all',
        name: 'Tất cả',
        // columnList: JSON.stringify(this.app.columnListAll.map(c => c.name))
      });
      let key = `${this.app.user.id}_${this.app.user.swUsername}`;
      let processMap = this.getProcessFromLocalStorge();
      this.app.globalProcessId = processMap[key] || this.app.processList[0].id;
      this.setProcessLocalStorage(key, this.app.globalProcessId);
    },
    async getColumnExtends() {
      const processId = this.app.globalProcessId === 'all' ? 0 : this.app.globalProcessId;
      const res = await HTTP.get("/api/column/get-all?processId=" + processId);
      this.$set(this.app, "columnListAll", res.data);
    },
    async getPermissionList() {
      const res = await HTTP.get("/api/employee/permission-list");
      this.$set(this.app, "permissionList", res.data);
    },
    async getEmployeeList() {
      const res = await HTTP.get("/api/employee/all");

      if (this.app.user.swUsername && this.app.user.type !== "ADMIN") {
        const existUser = res.data.find(
          (e) => e.username === this.app.user.swUsername
        );
        this.app.user.role = JSON.parse(JSON.stringify(existUser.role));
        this.app.role = JSON.parse(JSON.stringify(existUser.role));
      }

      this.$set(this.app, "employeeList", res.data);
      if (this.app.user.type === 'EMPLOYEE') {
        const res1 = await HTTP.get("/api/team/get-member-by-employee");
        if (res1.data.length == 0) {
          this.$set(this.app, "employeeTeam", this.app.employeeList.filter(em => em.username == this.app.user.swUsername && em.active));
        } else {
          this.$set(this.app, "employeeTeam", res1.data);
        }
      } else {
        this.$set(this.app, "employeeTeam", this.app.employeeList);
      }

      this.app.employeeTeam = this.app.employeeTeam.map(e => {
        return {
          ...e,
          accessible: e.active,
        };
      });
    },
    async getStorageList() {
      const res = await HTTP.get("/api/storage/get-all");
      this.$set(this.app, "storageAll", res.data.storageList);
      this.$set(this.app, "storageList", res.data.storageOptions);
    },
    
    // async getWorkflowList() {
    //   const res = await HTTP.get("/api/workflow/get-all");
    //   this.$set(this.app, "workflowList", res.data);
    // },
    async getReportList() {
      const res = await HTTP.get("/api/report", { params: { processId: this.app.globalProcessId } });
      this.$set(this.app, "reportList", res.data);
    },
    async getRoleOfUser() { },
    async getConnectionOmicall() {
      const res = await HTTP.get("/api/call/omicall/get-connection");
      if (res?.status == "error" || this.app.user.companyCode == 'sota') {
        console.log("OMICALL_LOG", res.error);
      } else {
        const payload = {
          domain: res.payload.pbx_account.sip_realm,
          username: res.payload.pbx_account.sip_user,
          password: res.payload.pbx_account.sip_password,
        };
        initOmiCallSDK(payload);
        this.app.omicall = {
          status: "ACTIVE",
          domain: res.payload.pbx_account.sip_realm,
          username: res.payload.pbx_account.sip_user,
          password: res.payload.pbx_account.sip_password,
          sipNumber: res.payload.hotlines[0]
        };
      }
    },
    async getConnectionStringee() {
      const res = await HTTP.get("/api/call/get-settings");
      // Tài khoản chưa cấu hình Stringee thì không có dòng STRINGEE → column undefined.
      // Không guard sẽ crash "Cannot read properties of undefined (reading 'status')".
      const list = Array.isArray(res && res.data) ? res.data : [];
      const column = list.find((col) => col.code === "STRINGEE");
      if (!column || column.status === "INACTIVE") {
        return;
      } else {
        const currentData = JSON.parse(column.config);
        const connectData = {
          apiSidKey: currentData.api_sid_key,
          apiSecretKey: currentData.api_secret_key,
          expires: 360000,
        };
        const connect = await HTTP.post("/api/call/generateToken", connectData);
        const payload = {
          accessToken: connect.data,
        };
        await initStringeeSDK(payload);
      }
    },
    async getConnectionPitel() {
      const res = await HTTP.get("/api/call/pitel/get-connection");
      if (res.data) {
        res.data.swUsername = this.app.user.swUsername;
        const resPitel = await initSDK(res.data);
        this.app.pitel = {
          status: "ACTIVE",
          deviceCode: resPitel.pitelNumber,
          username: resPitel.pitelNumber
        };
      }
    },
    async getListNumberStringee() {
      const res = await HTTP.get("/api/call/stringee/get-phone-numbers");
      if (res.error) {
        this.$message.error(res.error.message);
        return;
      }
      const numberList = JSON.parse(res.data)?.data.numbers;
      const phoneNumbers = numberList.map((item) => item.phone_number);
      this.$set(this.app, "stringeeNumbers", phoneNumbers);
      const fromNumbers = phoneNumbers.map((phoneNumber) => ({
        alias: `Số-${phoneNumber}`,
        number: phoneNumber,
      }));
      window.StringeeSoftPhone.config({ fromNumbers: fromNumbers });
    },
    handleStringeeDialog() {
      if (
        !window.StringeeSoftPhone ||
        typeof window.StringeeSoftPhone.config !== "function"
      ) {
        console.error(
          "StringeeSoftphone is not initialized or config function is unavailable."
        );
        return;
      }

      if (this.showModeStringee === "full") {
        this.showModeStringee = "none";
        window.StringeeSoftPhone.config({ showMode: this.showModeStringee });
      } else {
        this.showModeStringee = "full";
        window.StringeeSoftPhone.config({ showMode: this.showModeStringee });
      }
    },
    collapseMenu() {
      this.menuOpen = !this.menuOpen;
    },
    updateDisplay() {
      const companyCode = this.app.user.companyCode || "defaultCompany";
      const userName = this.app.user.swUsername || "defaultUser";

      let displayByUser = JSON.parse(localStorage.getItem("displayByUser")) || {};

      this.app.processList
        .filter(process => process.id !== 'all')
        .forEach(process => {
          const processId = process.id;

          if (
            displayByUser &&
            displayByUser[companyCode] &&
            displayByUser[companyCode][userName] &&
            displayByUser[companyCode][userName][processId]
          ) {
            const displayOrder = displayByUser[companyCode][userName][processId].displayOrder;

            if (displayOrder) {
              const columnShow = this.columnListByProcess
                .map((item) => ({
                  ...item,
                  FILE_IMPORT: item.require ? true : !!item.displayColumns.find(
                    (c) => c.columnDisplay === "FILE_IMPORT"
                  ),
                  QUICK_CREATE: item.require ? true : !!item.displayColumns.find(
                    (c) => c.columnDisplay === "QUICK_CREATE"
                  ),
                  PAGE_CUSTOMER: item.require ? true : !!item.displayColumns.find(
                    (c) => c.columnDisplay === "PAGE_CUSTOMER"
                  ),
                }))
                .filter((column) => {
                  const skipPermissionCheckFields = [
                    "note",
                    "createAt",
                    "contactWorkflow",
                  ];
                  if (skipPermissionCheckFields.includes(column.name)) {
                    return true;
                  }

                  const hasPermission = this.checkPermissionFieldRead(column.name);
                  return hasPermission;
                });

              const pageCustomerNames = (displayOrder.pageCustomer || []).map(col => col.name);
              const quickCreateNames = (displayOrder.quickCreate || []).map(col => col.name);
              const fileImportNames = (displayOrder.fileImport || []).map(col => col.name);

              const columnNotInPageCustomer = columnShow.filter(
                col => !pageCustomerNames.includes(col.name) && col.require
              );
              const columnNotInQuickCreate = columnShow.filter(
                col => !quickCreateNames.includes(col.name) && col.require
              );
              const columnNotInFileImport = columnShow.filter(
                col => !fileImportNames.includes(col.name) && col.require
              );

              const pageCustomer = [...(displayOrder.pageCustomer || []), ...columnNotInPageCustomer];
              const quickCreate = [...(displayOrder.quickCreate || []), ...columnNotInQuickCreate];
              const fileImport = [...(displayOrder.fileImport || []), ...columnNotInFileImport];

              displayByUser[companyCode][userName][processId].displayOrder.pageCustomer = pageCustomer;
              displayByUser[companyCode][userName][processId].displayOrder.quickCreate = quickCreate;
              displayByUser[companyCode][userName][processId].displayOrder.fileImport = fileImport;
            }
          }
        });

      localStorage.setItem("displayByUser", JSON.stringify(displayByUser));
    },
    startAppointmentTimer() {
      if (this.appointmentTimer) clearInterval(this.appointmentTimer);

      this.appointmentTimer = setInterval(() => {
        this.$bus.$emit('updateAppointmentStatusAuto');
      }, 30 * 1000);
    },
    getConnectionSwCall() {
      initSwCall();
    },
    getConnectionAI() {
      initAISDK(this.app.user.companyCode);
    }
  },
  created() {
    const params = new URLSearchParams(window.location.search)
    this.app.isEmbed = params.get('embed') === 'true'
    this.verify();

    document.addEventListener("Omicall_ended", (data) => {
      console.log("🚀 ~ document.addEventListener ~ data:", data);
      this.callResultData = data.detail;
    });

    document.addEventListener("Pitel_call_created", (data) => {
      this.callResultPitel = data.detail;
      HTTP.post("/api/call/create-call", {
        callCenterCode: "PITEL",
        callId: this.callResultPitel.extra.callId,
        contactId: 0,
        phone: this.callResultPitel.remoteNumber,
        deviceCode: this.app.pitel.deviceCode,
        direction: "",
        provider: "",
        processId:
          this.app.globalProcessId == "all"
            ? null
            : this.app.globalProcessId,
      });
    });

    document.addEventListener("Stringee_endedCall", (data) => {
      console.log(
        "🚀 ~ document.addEventListener ~ data Stringee:",
        data.detail
      );
      this.callResultData = data.detail;
    });

    document.addEventListener("Stringee_call", (data) => {
      this.app.stringee.fromNumberStringee = data.detail.fromPhone;
    });

    document.addEventListener("Stringee_newtoken", async () => {
      await this.getConnectionStringee();
    });

    document.addEventListener("Stringee_incommingcall", async (data) => {
      console.log("incommingCall:12345", data);
      this.callStringee = data.detail;
      console.log(
        "🚀 ~ document.addEventListener ~ this.callStringee:",
        this.callStringee
      );
    });

    document.addEventListener(
      "Stringee_incommingcallAnswered",
      async (data) => {
        console.log("incommingCallAns:", data);
      }
    );

    document.addEventListener("Stringee_authen", async (data) => {
      if (data.detail.r == "0") {
        this.app.stringee = {
          status: "ACTIVE",
        };
        this.getListNumberStringee();
      } else {
        this.$message.error(
          "API Key SID hoặc API Key Secret kết nối Stringee không chính xác."
        );
      }
    });

    document.addEventListener("Stringee_info", async (data) => {
      console.log("info:", data.detail);
    });

    document.addEventListener("Stringee_state", (data) => {
      console.log("state:", data.detail);
    });

    document.addEventListener("Stringee_beforeCall", async (data) => {
      console.log("resBeforeCall", data.detail);
      this.callStringeeData = data.detail;
    });

    document.addEventListener("Stringee_changDisplayMode", async (data) => {
      if (
        !window.StringeeSoftPhone ||
        typeof window.StringeeSoftPhone.config !== "function"
      ) {
        console.error(
          "StringeeSoftphone is not initialized or config function is unavailable."
        );
        return;
      }
      if (data.detail == "min") {
        this.showModeStringee = "none";
        window.StringeeSoftPhone.config({ showMode: "none" });
      } else if (data.detail == "none") {
        this.showModeStringee = "none";
      } else {
        this.showModeStringee = "full";
      }
    });
  },

  mounted() {
    if (!this.app.isEmbed) {
      this.getConnectionOmicall();
      this.getConnectionStringee();
      this.getConnectionPitel();
    }
    this.$bus.$on('changeProcessId', () => {
      this.getColumnExtends();
    });
    this.$bus.$on('showContactNoti', (data) => {
      this.contactNoti = data.contact;
      this.workflow = data.workflow;
      this.showNoticontact = true;
    });
    this.$bus.$on("notification", (data) => {
      this.handleNotification(data);
    })
    this.$bus.$on("notificationAppointment", (data) => {
      this.handleNotificationAppointment(data);
    })
    this.$bus.$on("appointment", (data) => this.handleAlarmAppointment(data));
    this.startAppointmentTimer();
    window.addEventListener("callwebsdk:ua-connected", () => {
      this.app.swCall.status = 'ACTIVE';
    });
  },
};
</script>

<style lang="scss">
/* #app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
} */

.preloader {
  display: flex;
  flex-direction: column;
  top: 38%;
  left: 45%;
  position: absolute;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  line-height: 32px;
  font-family: Arial, Helvetica, sans-serif;
}

.btn-collapse {
  position: absolute;
  bottom: 120px;
  left: 202px;
  height: 32px;
  width: 32px;
  border-radius: 50%;
  cursor: pointer;
  z-index: 2;
  background: #157fd9;
  transition: all 0.4s ease;
}

.collapse {
  left: 40px;
  transition: all 0.4s ease;
}

.backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10001;
}
</style>
